export enum AnimationVariants {
  hidden = 'hidden',
  visible = 'visible'
}
